import * as z from "zod/v4";

const AiReturnReasonsInputSchema_ = z.discriminatedUnion("action", [
  z.object({
    action: z.literal("generate_followup"),
    initialResponse: z.string().min(1).max(2000),
  }),
  z.object({
    action: z.literal("classify"),
    initialResponse: z.string().min(1).max(2000),
    followUpResponse: z.string().min(1).max(2000),
  }),
]);
export const AiReturnReasonsInputSchema: z.ZodType<AiReturnReasonsInput> =
  AiReturnReasonsInputSchema_;
export type AiReturnReasonsInput = {} & z.infer<
  typeof AiReturnReasonsInputSchema_
>;

const CLASSIFICATION_VALUES = ["wrong_product", "damaged", "other"] as const;

const AiReturnReasonsOutputSchema_ = z.object({
  followUpQuestion: z.string().optional(),
  classification: z.enum(CLASSIFICATION_VALUES).optional(),
});
export const AiReturnReasonsOutputSchema: z.ZodType<AiReturnReasonsOutput> =
  AiReturnReasonsOutputSchema_;
export interface AiReturnReasonsOutput
  extends z.infer<typeof AiReturnReasonsOutputSchema_> {}

export const aiReturnReasons = {
  name: "aiReturnReasons" as const,
  input: AiReturnReasonsInputSchema,
  output: AiReturnReasonsOutputSchema,
};
